import PropTypes from "prop-types";
import React from "react";
import { MobileHeaderButton } from "../components/Button";
import styled from "styled-components";
import logout from "../icons/logout.svg";
import angleLeft from "../icons/angle-left.svg";
import { Logo } from "../components/Logo";
import { injectIntl, defineMessages, FormattedMessage } from "react-intl";
import defaults from "../config/defaults.json";
import ErrorDisplay, { ErrorPropTypeShape } from "../errors/ErrorDisplay";

const messages = defineMessages( {
	signOut: {
		id: "mobileheader.signout",
		defaultMessage: "Sign out",
	},
	signingOut: {
		id: "mobileheader.signout.pending",
		defaultMessage: "Signing out...",
	},
	needHelp: {
		id: "mobileheader.needhelp",
		defaultMessage: "Need help?",
	},
	back: {
		id: "mobileheader.back",
		defaultMessage: "Back",
	},
} );

const FixedMobileHeader = styled.header`
	display: inline-block;
	position: fixed;
	z-index: 1;
	width: 100%;
	height: 48px;
	top: 0;
	background-color: var(--bg-color-purple);
`;

export const LogoutHeaderButton = styled( MobileHeaderButton )`
	top: 0;
	left: 0;

	@media screen and ( max-width: ${ defaults.css.breakpoint.mobile }px ) {
		width: 56px;
		padding-right: 0;
	}
`;

/**
 * Renders the FixedMobileHeader component.
 *
 * @param {Object} props Component props.
 * @returns {ReactElement} A react component.
 */
function MobileHeader( props ) {
	let buttonMessage = props.loggingOut ? messages.signingOut : messages.signOut;

	let onButtonClick = () => {
		props.onLogoutClick();
	};

	let buttonIcon = logout;

	if ( props.detailPage ) {
		buttonMessage = messages.back;
		onButtonClick = props.onBackClick;
		buttonIcon = angleLeft;
	}

	const hideButton = props.hideButton;

	return (
		<FixedMobileHeader>
			{ props.detailPage && <h1 hidden={ true }>{ props.pageTitle }</h1> }
			{ ! hideButton && (
				<MobileHeaderButton type="button" onClick={ onButtonClick } iconSource={ buttonIcon } iconSize="24px">
					<FormattedMessage { ...buttonMessage } />
				</MobileHeaderButton>
			) }
			<ErrorDisplay error={ props.logoutError } showIcon={ false } />
			{ ! hideButton && (
				<Logo context="header" />
			) }
		</FixedMobileHeader>
	);
}

export default injectIntl( MobileHeader );

MobileHeader.propTypes = {
	onLogoutClick: PropTypes.func.isRequired,
	onBackClick: PropTypes.func,
	detailPage: PropTypes.bool,
	match: PropTypes.object,
	pageTitle: PropTypes.string,
	loggingOut: PropTypes.bool,
	logoutError: ErrorPropTypeShape,
	hideButton: PropTypes.bool,
};

MobileHeader.defaultProps = {
	onBackClick: null,
	detailPage: false,
	match: null,
	pageTitle: "",
	loggingOut: false,
	logoutError: null,
	hideButton: false,
};
